export const buildSmartLinkPayloadBl = (formData) => {
  return {
    amount: Number(formData.amount),
    unique: formData.unique === "true", // Conversión de string del select a booleano
    reference: formData.reference, 
    paymentConcept: formData.paymentConcept,
    response: true,
    expiration: formData.expiration || undefined, // YYYY-MM-DD
    promotion: formData.promotion === "true" || formData.promotion === true,
    name: formData.name,
    address: formData.address,
    phone: formData.phone,
    email: formData.email
   // urlCallback: formData.urlCallback
  };
};